import { client } from '@/common-utils/libraries/axios/axios';
import DOCUMENTATION from '../apiUrls';
import DOCUMENTATION_FIELDS from '../../fields/DocumentationFields';

const mapResponseData = (responseData) => {
    const data = {
        [DOCUMENTATION_FIELDS.URL.key]: responseData[DOCUMENTATION_FIELDS.URL.key]
    };

    return data;
};

const queryGetPayluddMerchantGuideDocumentation = (enabled = true) => {
    return {
        queryKey: [DOCUMENTATION.MERCHANT_PAYLUDD_GUIDE.queryKey],
        queryFn: async () => {
            const response = await client.get(DOCUMENTATION.MERCHANT_PAYLUDD_GUIDE.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetPayluddMerchantGuideDocumentation;